<template>
    <div>
        <!-- 移动端卡片模式 -->
        <div v-if="cardMode" class="space-y-3">
            <!-- 语言转换卡片 - 增强版 -->
            <div class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <button @click="openLanguageDrawer()" :disabled="isLoading"
                        class="flex items-center justify-between w-full text-left">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-primary/10 rounded-lg">
                                <svg t="1704703866798" class="w-6 h-6 fill-primary" viewBox="0 0 1024 1024">
                                    <path d="M716.8 76.8a230.4 230.4 0 0 1 230.4 230.4v409.6a230.4 230.4 0 0 1-230.4 230.4H307.2a230.4 230.4 0 0 1-230.4-230.4V307.2a230.4 230.4 0 0 1 230.4-230.4h409.6m0-76.8H307.2A307.2 307.2 0 0 0 0 307.2v409.6a307.2 307.2 0 0 0 307.2 307.2h409.6a307.2 307.2 0 0 0 307.2-307.2V307.2A307.2 307.2 0 0 0 716.8 0z"/>
                                    <path d="M319.744 309.76l-19.2 22.272h202.752c0 23.808 0 45.824-1.792 66.304h34.56v39.936h-37.632c0 9.472-2.304 21.248-4.864 35.584h23.296v32.512H486.4l-3.072 10.496 17.152 13.056a763.136 763.136 0 0 1-96 39.936l118.784-4.352c20.736-10.752 46.592-25.6 76.8-41.728l44.8 29.44a984.32 984.32 0 0 1-222.464 92.16q102.4-4.096 220.672-12.288c-17.152-13.056-30.208-22.528-39.424-28.416l44.288-28.16a1037.056 1037.056 0 0 1 136.448 97.792l-51.2 34.304c-11.52-11.008-25.6-24.064-44.288-39.424l-146.688 8.704v68.096c0 34.56-20.224 51.2-60.928 51.2h-54.016l-11.008-51.2a478.976 478.976 0 0 0 49.664 3.072 15.616 15.616 0 0 0 17.92-17.152v-51.2c-62.464 3.328-128 5.888-200.96 7.936l-13.568-51.2c17.152 1.28 34.304 1.792 51.2 1.792a784.64 784.64 0 0 0 128-39.936l-131.584 5.12-9.728-45.824a146.176 146.176 0 0 0 47.872-5.376 798.464 798.464 0 0 0 75.52-33.792l3.84-13.056h-174.848c4.864-30.208 8.192-52.992 10.24-68.096H232.448v-39.936h42.496c2.304-20.48 4.096-35.84 4.864-46.08l-19.712 17.152-33.28-39.168a329.984 329.984 0 0 0 86.784-102.4l52.736 11.776-15.36 27.136h177.664v43.008z"/>
                                </svg>
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('语言转换') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('简繁体智能转换') }} · {{ languageTypeLabel }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md ml-2" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50 ml-2" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                            </svg>
                        </div>
                    </button>
                </div>
            </div>

            <!-- 拆分元数据按钮卡片 -->
            <div
                class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <div for="split-filename" class="flex items-center justify-between cursor-pointer" @click="splitFilenameCheckBox = true">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-info/10 rounded-lg">
                                <svg viewBox="0 0 14 16" class="w-6 h-6 fill-info" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M2.5 0.25C1.25736 0.25 0.25 1.25736 0.25 2.5V3H1.75V2.5C1.75 2.08579 2.08579 1.75 2.5 1.75H11.5C11.9142 1.75 12.25 2.08579 12.25 2.5V3H13.75V2.5C13.75 1.25736 12.7426 0.25 11.5 0.25H2.5Z" />
                                    <path
                                        d="M1.75 13.5V7.5H0.25V13.5C0.25 14.7426 1.25736 15.75 2.5 15.75H11.5C12.7426 15.75 13.75 14.7426 13.75 13.5V7.5H12.25V13.5C12.25 13.9142 11.9142 14.25 11.5 14.25H2.5C2.08579 14.25 1.75 13.9142 1.75 13.5Z" />
                                    <path d="M2.5 4.5H0.25V6H2.5V4.5Z" />
                                    <path d="M6.51786 4.5H3.46429V6H6.51786V4.5Z" />
                                    <path d="M10.5357 4.5H7.48214V6H10.5357V4.5Z" />
                                    <path d="M13.75 4.5H11.5V6H13.75V4.5Z" />
                                </svg>
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('拆分元数据') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('从文件名提取音乐信息') }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 替换文本按钮卡片 -->
            <div
                class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <div for="replace-text" class="flex items-center justify-between cursor-pointer" @click="replaceTextCheckBox = true">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-warning/10 rounded-lg">
                                <svg viewBox="0 0 16 16" class="w-6 h-6 fill-warning"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.503 2.5L7.503 7.5L2.503 7.5L7.503 12.5L12.503 7.5L7.503 7.5L7.503 2.5Z" />
                                </svg>
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('替换文本') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('批量替换无关文本信息') }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 乱码修复卡片 - 增强版 -->
            <div class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <button @click="openEncodingDrawer()" :disabled="isLoading"
                        class="flex items-center justify-between w-full text-left">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-warning/10 rounded-lg">
                                <svg class="w-6 h-6 fill-warning" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('乱码修复') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('编码智能检测 · UTF-8转换') }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md ml-2" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50 ml-2" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                            </svg>
                        </div>
                    </button>
                </div>
            </div>
        </div>

        <!-- 桌面端原有模式 -->
        <div v-else>
            <!-- 语言转换按钮 -->
            <div class="mt-2">
                <button :theme="'success'" @click="openLanguageDrawer()"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('语言转换')" :disabled="isLoading">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                        <svg t="1704703866798" class="icon w-16 h-6 fill-current" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="12326" width="200" height="200">
                            <path
                                d="M716.8 76.8a230.4 230.4 0 0 1 230.4 230.4v409.6a230.4 230.4 0 0 1-230.4 230.4H307.2a230.4 230.4 0 0 1-230.4-230.4V307.2a230.4 230.4 0 0 1 230.4-230.4h409.6m0-76.8H307.2A307.2 307.2 0 0 0 0 307.2v409.6a307.2 307.2 0 0 0 307.2 307.2h409.6a307.2 307.2 0 0 0 307.2-307.2V307.2A307.2 307.2 0 0 0 716.8 0z"
                                p-id="12327"></path>
                            <path
                                d="M319.744 309.76l-19.2 22.272h202.752c0 23.808 0 45.824-1.792 66.304h34.56v39.936h-37.632c0 9.472-2.304 21.248-4.864 35.584h23.296v32.512H486.4l-3.072 10.496 17.152 13.056a763.136 763.136 0 0 1-96 39.936l118.784-4.352c20.736-10.752 46.592-25.6 76.8-41.728l44.8 29.44a984.32 984.32 0 0 1-222.464 92.16q102.4-4.096 220.672-12.288c-17.152-13.056-30.208-22.528-39.424-28.416l44.288-28.16a1037.056 1037.056 0 0 1 136.448 97.792l-51.2 34.304c-11.52-11.008-25.6-24.064-44.288-39.424l-146.688 8.704v68.096c0 34.56-20.224 51.2-60.928 51.2h-54.016l-11.008-51.2a478.976 478.976 0 0 0 49.664 3.072 15.616 15.616 0 0 0 17.92-17.152v-51.2c-62.464 3.328-128 5.888-200.96 7.936l-13.568-51.2c17.152 1.28 34.304 1.792 51.2 1.792a784.64 784.64 0 0 0 128-39.936l-131.584 5.12-9.728-45.824a146.176 146.176 0 0 0 47.872-5.376 798.464 798.464 0 0 0 75.52-33.792l3.84-13.056h-174.848c4.864-30.208 8.192-52.992 10.24-68.096H232.448v-39.936h42.496c2.304-20.48 4.096-35.84 4.864-46.08l-19.712 17.152-33.28-39.168a329.984 329.984 0 0 0 86.784-102.4l52.736 11.776-15.36 27.136h177.664v43.008z m108.032 419.84a727.808 727.808 0 0 1-167.68 64l-23.296-49.152A623.104 623.104 0 0 0 394.752 691.2z m-106.24-296.96l-6.656 41.216h87.04a390.912 390.912 0 0 0-61.952-21.504l12.8-19.712z m41.728-68.608H330.24l-4.352 40.96h76.8a337.92 337.92 0 0 0-53.504-20.992z m44.288 109.824h35.584l6.912-41.216h-86.784a512 512 0 0 1 57.856 20.48z m44.8-68.864l1.792-40.96h-83.456a358.4 358.4 0 0 1 55.808 22.016l-12.288 18.944z m119.296-33.024q-9.216 11.264-27.648 30.72l-33.792-40.704a412.16 412.16 0 0 0 82.176-135.68l54.272 12.288-19.2 43.008h157.952v51.2h-34.304a284.928 284.928 0 0 1-51.2 107.52 469.248 469.248 0 0 0 98.304 43.776l-28.928 51.2a460.8 460.8 0 0 1-108.288-55.808 294.656 294.656 0 0 1-111.104 52.736l-28.928-45.568a270.336 270.336 0 0 0 99.072-43.008 237.568 237.568 0 0 1-48.384-71.68zM614.4 688.896A1068.032 1068.032 0 0 1 781.824 742.4l-32 51.2a926.464 926.464 0 0 0-168.448-57.088z m-9.216-358.4a180.736 180.736 0 0 0 51.2 76.8 244.736 244.736 0 0 0 41.728-76.8z"
                                p-id="12328"></path>
                        </svg>
                        <div v-if="detail" class="mr-auto">{{ $tt('语言转换') }}</div>
                    </span>
                </button>
            </div>

            <!-- 拆分元数据按钮 -->
            <div class="mt-2">
                <div for="split-filename"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('拆分元数据')" :disabled="isLoading" @click="splitFilenameCheckBox = true">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                        <svg viewBox="0 0 14 16" class="icon fill-current w-16 h-5" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2.5 0.25C1.25736 0.25 0.25 1.25736 0.25 2.5V3H1.75V2.5C1.75 2.08579 2.08579 1.75 2.5 1.75H11.5C11.9142 1.75 12.25 2.08579 12.25 2.5V3H13.75V2.5C13.75 1.25736 12.7426 0.25 11.5 0.25H2.5Z" />
                            <path
                                d="M1.75 13.5V7.5H0.25V13.5C0.25 14.7426 1.25736 15.75 2.5 15.75H11.5C12.7426 15.75 13.75 14.7426 13.75 13.5V7.5H12.25V13.5C12.25 13.9142 11.9142 14.25 11.5 14.25H2.5C2.08579 14.25 1.75 13.9142 1.75 13.5Z" />
                            <path d="M2.5 4.5H0.25V6H2.5V4.5Z" />
                            <path d="M6.51786 4.5H3.46429V6H6.51786V4.5Z" />
                            <path d="M10.5357 4.5H7.48214V6H10.5357V4.5Z" />
                            <path d="M13.75 4.5H11.5V6H13.75V4.5Z" />
                        </svg>
                        <div v-if="detail" class="mr-auto">{{ $tt('拆分元数据') }}</div>
                    </span>
                </div>
            </div>

            <!-- 替换文本按钮 -->
            <div class="mt-2">
                <div for="replace-text"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('替换文本')" :disabled="isLoading" @click="replaceTextCheckBox = true">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                        <svg class="icon fill-current w-16 h-6" viewBox="0 0 12 16" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M12.0001 4.25006V5.75006L0 5.75006V4.93951L3.96979 0.969727L5.03045 2.03039L2.81078 4.25006L12.0001 4.25006ZM0.000116289 11.7501L0.000116348 10.2501L12 10.2501V11.0608L8.03045 15.0304L6.96979 13.9697L9.18946 11.7501H0.000116289Z" />
                        </svg>
                        <div v-if="detail" class="mr-auto">{{ $tt('替换文本') }}</div>
                    </span>
                </div>
            </div>

            <!-- 乱码修复按钮 -->
            <div class="mt-2">
                <button :theme="'success'" @click="openEncodingDrawer()"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('乱码修复')" :disabled="isLoading">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                        <svg-icon name="fix-encoding" class="w-16 h-7  fill-current" />
                        <div v-if="detail" class="mr-auto">{{ $tt('乱码修复') }}</div>
                    </span>
                </button>
            </div>
        </div>

        <!-- 语言转换抽屉 - 优化版 -->
        <div class="drawer">
            <input id="language-converter" type="checkbox" class="drawer-toggle" v-model="languageDrawerOpen" />
            <div class="drawer-side z-50">
                <div @click="languageDrawerOpen = false" class="drawer-overlay"></div>
                <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4 flex flex-col">
                    
                    <!-- 标准头部 -->
                    <div class="flex items-center justify-between p-4 border-b border-base-200">
                        <div class="flex items-center space-x-3">
                            <div class="w-1 h-5 bg-primary/40 rounded-full"></div>
                            <h2 class="text-xl font-medium">{{ $tt('语言转换') }}</h2>
                            <div class="badge badge-primary badge-outline badge-sm">{{ $tt('智能转换') }}</div>
                        </div>
                        <div>
                            <button class="btn btn-sm btn-neutral" @click="handleChangeLanguageFunc">{{ $tt('确认') }}</button>
                            <button class="btn btn-sm ml-1" @click="languageDrawerOpen = false">{{ $tt('取消') }}</button>
                        </div>
                    </div>
                    
                    <!-- 内容区域 -->
                    <div class="flex-1 p-4 space-y-6 overflow-y-auto">
                        
                        <!-- 功能说明分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('功能说明') }}</h3>
                                <div class="badge badge-ghost badge-sm">{{ $tt('智能识别') }}</div>
                            </div>
                            
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="bg-primary/10 border border-primary/20 rounded-lg p-4">
                                    <div class="flex items-start gap-3">
                                        <svg class="w-5 h-5 text-primary mt-0.5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                                        </svg>
                                        <div>
                                            <h4 class="font-medium text-primary mb-1">{{ $tt('智能语言转换') }}</h4>
                                            <p class="text-sm text-base-content/70">
                                                {{ $tt('自动识别简体中文和繁体中文，支持双向转换。适用于音乐标签中的艺术家、专辑、歌曲名等字段的字体转换。') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 转换方向分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-primary/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('转换方向') }}</h3>
                                <div class="badge badge-primary badge-outline badge-sm">{{ $tt('双向转换') }}</div>
                            </div>
                            
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <input type="radio" class="radio radio-primary" value="sim2trad" v-model="languageType" />
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('简体转繁体') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('将简体中文转换为繁体中文') }}</div>
                                        </div>
                                    </label>
                                </div>
                                
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <input type="radio" class="radio radio-primary" value="trad2sim" v-model="languageType" />
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('繁体转简体') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('将繁体中文转换为简体中文') }}</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- 修改范围分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-primary/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('修改范围') }}</h3>
                                <div class="badge badge-primary badge-outline badge-sm">{{ $tt('{count} 个字段', { count: modifyListL.length }) }}</div>
                            </div>
                            
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="multi-select-container">
                                    <multi-select :options="modifyListLanguage" v-model="modifyListL"></multi-select>
                                </div>
                                <div class="text-xs text-base-content/60 mt-2">
                                    {{ $tt('选择需要进行语言转换的元数据字段') }}
                                </div>
                            </div>
                        </div>

                        <!-- 预览示例分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('转换预览') }}</h3>
                                <div class="badge badge-ghost badge-sm">{{ $tt('实时预览') }}</div>
                            </div>
                            
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="bg-base-200/30 rounded-lg p-4 border border-base-300/50">
                                    <div class="grid grid-cols-2 gap-4 text-sm">
                                        <div>
                                            <div class="font-medium text-base-content/80 mb-2">{{ $tt('转换前') }}</div>
                                            <div class="bg-base-100 p-2 rounded border font-mono">
                                                {{ languageType === 'sim2trad' ? $tt('华语流行') : $tt('華語流行') }}
                                            </div>
                                        </div>
                                        <div>
                                            <div class="font-medium text-base-content/80 mb-2">{{ $tt('转换后') }}</div>
                                            <div class="bg-primary/10 p-2 rounded border font-mono text-primary">
                                                {{ languageType === 'sim2trad' ? $tt('華語流行') : $tt('华语流行') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

        <!-- 乱码修复抽屉 - 优化版 -->
        <div class="drawer">
            <input id="encoding-fixer" type="checkbox" class="drawer-toggle" v-model="encodingDrawerOpen" />
            <div class="drawer-side z-50">
                <div @click="encodingDrawerOpen = false" class="drawer-overlay"></div>
                <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4 flex flex-col">
                    
                    <!-- 标准头部 -->
                    <div class="flex items-center justify-between p-4 border-b border-base-200">
                        <div class="flex items-center space-x-3">
                            <div class="w-1 h-5 bg-warning/40 rounded-full"></div>
                            <h2 class="text-xl font-medium">{{ $tt('乱码修复') }}</h2>
                            <div class="badge badge-warning badge-outline badge-sm">{{ $tt('智能检测') }}</div>
                        </div>
                        <div>
                            <button class="btn btn-sm btn-neutral" @click="handleEncodingFix">{{ $tt('确认') }}</button>
                            <button class="btn btn-sm ml-1" @click="encodingDrawerOpen = false">{{ $tt('取消') }}</button>
                        </div>
                    </div>
                    
                    <!-- 内容区域 -->
                    <div class="flex-1 p-4 space-y-6 overflow-y-auto">
                        
                        <!-- 功能说明分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('功能说明') }}</h3>
                                <div class="badge badge-ghost badge-sm">{{ $tt('自动修复') }}</div>
                            </div>
                            
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="bg-warning/10 border border-warning/20 rounded-lg p-4">
                                    <div class="flex items-start gap-3">
                                        <svg class="w-5 h-5 text-warning mt-0.5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                                        </svg>
                                        <div>
                                            <h4 class="font-medium text-warning mb-1">{{ $tt('编码乱码修复') }}</h4>
                                            <p class="text-sm text-base-content/70">
                                                {{ $tt('智能检测并修复音乐文件元数据中的字符编码问题，支持GB2312、GBK、UTF-8等多种编码格式的自动转换。') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 检测范围分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-warning/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('检测范围') }}</h3>
                                <div class="badge badge-warning badge-outline badge-sm">{{ $tt('{count} 个字段', { count: modifyListL.length }) }}</div>
                            </div>
                            
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="multi-select-container">
                                    <multi-select :options="modifyListLanguage" v-model="modifyListL"></multi-select>
                                </div>
                                <div class="text-xs text-base-content/60 mt-2">
                                    {{ $tt('选择需要检测和修复乱码的元数据字段') }}
                                </div>
                            </div>
                        </div>

                        <!-- 常见乱码类型分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('常见问题') }}</h3>
                                <div class="badge badge-ghost badge-sm">{{ $tt('参考示例') }}</div>
                            </div>
                            
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="space-y-3">
                                    <div class="bg-base-200/50 rounded-lg p-3 border border-base-300/50">
                                        <h4 class="font-medium text-sm mb-2">{{ $tt('乱码类型示例') }}</h4>
                                        <div class="space-y-2 text-xs">
                                            <div class="flex items-center gap-2">
                                                <div class="w-2 h-2 bg-error rounded-full"></div>
                                                <code class="bg-base-300/50 px-2 py-1 rounded">ä¸­æ</code>
                                                <span class="text-base-content/60">→</span>
                                                <span class="text-success">{{ $tt('中文') }}</span>
                                            </div>
                                            <div class="flex items-center gap-2">
                                                <div class="w-2 h-2 bg-error rounded-full"></div>
                                                <code class="bg-base-300/50 px-2 py-1 rounded">???</code>
                                                <span class="text-base-content/60">→</span>
                                                <span class="text-success">{{ $tt('汉字') }}</span>
                                            </div>
                                            <div class="flex items-center gap-2">
                                                <div class="w-2 h-2 bg-error rounded-full"></div>
                                                <code class="bg-base-300/50 px-2 py-1 rounded">ÖÐÎÄ</code>
                                                <span class="text-base-content/60">→</span>
                                                <span class="text-success">{{ $tt('中文') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 拆分元数据 Drawer -->
        <div class="drawer">
            <input id="split-filename" type="checkbox" class="drawer-toggle" name='split-filename'
                v-model="splitFilenameCheckBox" />
            <div class="drawer-side">
                <div @click="splitFilenameCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>

                <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4">
                    <!-- 头部区域 -->
                    <div class="sticky top-0 z-10 bg-base-100 px-6 py-4">
                        <div class="flex justify-between items-center">
                            <div class="flex items-center gap-3">
                                <div class="p-2 bg-primary/10 rounded-lg">
                                    <svg viewBox="0 0 14 16" class="w-5 h-5 fill-primary"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.5 0.25C1.25736 0.25 0.25 1.25736 0.25 2.5V3H1.75V2.5C1.75 2.08579 2.08579 1.75 2.5 1.75H11.5C11.9142 1.75 12.25 2.08579 12.25 2.5V3H13.75V2.5C13.75 1.25736 12.7426 0.25 11.5 0.25H2.5Z" />
                                        <path
                                            d="M1.75 13.5V7.5H0.25V13.5C0.25 14.7426 1.25736 15.75 2.5 15.75H11.5C12.7426 15.75 13.75 14.7426 13.75 13.5V7.5H12.25V13.5C12.25 13.9142 11.9142 14.25 11.5 14.25H2.5C2.08579 14.25 1.75 13.9142 1.75 13.5Z" />
                                        <path d="M2.5 4.5H0.25V6H2.5V4.5Z" />
                                        <path d="M6.51786 4.5H3.46429V6H6.51786V4.5Z" />
                                        <path d="M10.5357 4.5H7.48214V6H10.5357V4.5Z" />
                                        <path d="M13.75 4.5H11.5V6H13.75V4.5Z" />
                                    </svg>
                                </div>
                                <div>
                                    <h2 class="text-lg font-semibold text-base-content">{{ $tt('拆分元数据') }}</h2>
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button class="btn btn-sm btn-neutral" @click="splitFilenameFunc">
                                    {{ $tt('确认') }}
                                </button>
                                <button class="btn btn-sm btn-ghost" @click="splitFilenameCheckBox = false">
                                    {{ $tt('取消') }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- 内容区域 -->
                    <div class="p-6 space-y-6">
                        <!-- 功能说明 -->
                        <div class="bg-info/10 border border-info/20 rounded-lg p-4">
                            <div class="flex items-start gap-3">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-info mt-0.5 flex-shrink-0"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <div>
                                    <h3 class="font-medium text-info mb-1">{{ $tt('功能说明') }}</h3>
                                    <p class="text-sm text-base-content/70">
                                        {{ $tt('通过正则表达式匹配规则，从文件名或其他元数据中提取出艺术家、专辑、标题等信息，并自动填充到对应的标签字段中。') }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- 提取源选择 -->
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                    {{ $tt('提取源') }}
                                </span>
                            </label>
                            <select class="select select-bordered" @change="handleExtractChange" v-model="extractField">
                                <option v-for="option in extractList" :key="option.id" :value="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                            <label class="label">
                                <span class="label-text-alt text-base-content/60">{{ $tt('选择要从哪个字段提取元数据信息') }}</span>
                            </label>
                        </div>

                        <!-- 拆分规则 -->
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                    </svg>
                                    {{ $tt('拆分规则') }}
                                </span>
                            </label>
                            <div class="space-y-3">
                                <div v-for="(item, index) in currentSplitRules" :key="item.id || index"
                                    class="px-3 py-2 bg-base-200/50 rounded-lg border border-base-300/50 hover:bg-base-200 transition-colors">
                                    <div class="flex items-center gap-3">
                                        <input type="checkbox" class="checkbox checkbox-sm" v-model="item.enabled"
                                            @change="handleRuleToggle" />
                                        <div class="flex-1 min-w-0">
                                            <span class="font-medium text-sm truncate block">{{ item.name || $tt('未命名规则') }}</span>
                                        </div>
                                        <div class="flex items-center gap-2 flex-shrink-0">
                                            <button class="btn btn-ghost btn-xs" @click="openSplitRuleEditor(item, index)">
                                                {{ $tt('编辑') }}
                                            </button>
                                            <button class="btn btn-ghost btn-xs text-error" @click="deleteRule(index)">
                                                {{ $tt('删除') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="!currentSplitRules.length"
                                    class="text-sm text-base-content/60 border border-dashed border-base-300 rounded-lg p-4 text-center">
                                    {{ $tt('当前分类下暂无规则，请新增规则') }}
                                </div>
                            </div>
                            <div class="mt-3 flex justify-between items-center gap-2 flex-wrap">
                                <div class="flex gap-2 flex-wrap">
                                    <button class="btn btn-sm btn-ghost" @click="openSplitRuleEditor()">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                                            viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M12 4v16m8-8H4" />
                                        </svg>
                                        {{ $tt('添加规则') }}
                                    </button>
                                    <button class="btn btn-sm btn-ghost" @click="restoreDefaultRules">
                                        {{ $tt('恢复默认规则') }}
                                    </button>
                                </div>
                                <span class="text-xs text-base-content/60">{{ $tt('{count} 条规则', { count: currentSplitRules.length }) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 替换文本 Drawer -->
        <div class="drawer">
            <input id="replace-text" type="checkbox" class="drawer-toggle" v-model="replaceTextCheckBox" />
            <div class="drawer-side">
                <div @click="replaceTextCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>

                <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4">
                    <!-- 头部区域 -->
                    <div class="sticky top-0 z-10 bg-base-100 px-6 py-4">
                        <div class="flex justify-between items-center">
                            <div class="flex items-center gap-3">
                                <div class="p-2 bg-warning/10 rounded-lg">
                                    <svg class="w-5 h-5 fill-warning" viewBox="0 0 12 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M12.0001 4.25006V5.75006L0 5.75006V4.93951L3.96979 0.969727L5.03045 2.03039L2.81078 4.25006L12.0001 4.25006ZM0.000116289 11.7501L0.000116348 10.2501L12 10.2501V11.0608L8.03045 15.0304L6.96979 13.9697L9.18946 11.7501H0.000116289Z" />
                                    </svg>
                                </div>
                                <div>
                                    <h2 class="text-lg font-semibold text-base-content">{{ $tt('替换文本') }}</h2>
                                    <p class="text-sm text-base-content/70">{{ $tt('智能清理无关信息') }}</p>
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button class="btn btn-sm btn-neutral" @click="replaceTextFunc">
                                    {{ $tt('确认') }}
                                </button>
                                <button class="btn btn-sm btn-ghost" @click="replaceTextCheckBox = false">
                                    {{ $tt('取消') }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- 内容区域 -->
                    <div class="p-6 space-y-6">
                        <!-- 功能说明 -->
                        <div class="bg-warning/10 border border-warning/20 rounded-lg p-4">
                            <div class="flex items-start gap-3">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                    class="w-5 h-5 text-warning mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <div>
                                    <h3 class="font-medium text-warning mb-1">{{ $tt('功能说明') }}</h3>
                                    <p class="text-sm text-base-content/70">
                                        {{ $tt('清除隐藏在元数据中的无关信息，支持文本替换和正则表达式替换两种模式。') }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- 替换模式选择 -->
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    {{ $tt('替换模式') }}
                                </span>
                            </label>
                            <single-select v-model="replaceMode" :options="replaceOptions" :placeholder="$tt('请选择替换模式')">
                            </single-select>
                            <label class="label">
                                <span class="label-text-alt text-base-content/60">{{ $tt('选择文本替换或正则表达式替换') }}</span>
                            </label>
                        </div>

                        <!-- 修改范围 -->
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                    </svg>
                                    {{ $tt('修改范围') }}
                                </span>
                            </label>
                            <multi-select :options="modifyListLanguage" v-model="modifyListL"></multi-select>
                            <label class="label">
                                <span class="label-text-alt text-base-content/60">{{ $tt('选择要修改的元数据字段') }}</span>
                            </label>
                        </div>

                        <!-- 替换规则 -->
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                    </svg>
                                    {{ $tt('替换规则') }}
                                </span>
                            </label>
                            <div class="space-y-3">
                                <div v-for="(item, index) in replaceTextList" :key="index"
                                    class="p-3 bg-base-200/50 rounded-lg border border-base-300/50 hover:bg-base-200 transition-colors">
                                    <div class="flex items-center gap-2 mb-2">
                                        <div
                                            class="flex-shrink-0 w-6 h-6 bg-warning/20 text-warning rounded-full flex items-center justify-center text-sm font-medium">
                                            {{ index + 1 }}
                                        </div>
                                        <span class="text-sm font-medium text-base-content/80">{{ $tt('规则 {index}', { index: index + 1 }) }}</span>
                                        <button
                                            class="btn btn-ghost btn-sm btn-circle opacity-60 hover:opacity-100 ml-auto"
                                            @click="replaceTextList.splice(index, 1)" v-if="replaceTextList.length > 1"
                                            :disabled="replaceTextList.length <= 1">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div class="grid grid-cols-2 gap-2">
                                        <div class="form-control">
                                            <label class="label py-1">
                                                <span class="label-text text-xs">{{ $tt('替换前') }}</span>
                                            </label>
                                            <input type="text" :placeholder="$tt('要替换的内容')"
                                                class="input input-bordered input-sm w-full bg-base-100 focus:bg-base-100"
                                                v-model="item.before" />
                                        </div>
                                        <div class="form-control">
                                            <label class="label py-1">
                                                <span class="label-text text-xs">{{ $tt('替换后') }}</span>
                                            </label>
                                            <input type="text" :placeholder="$tt('替换后内容（可为空）')"
                                                class="input input-bordered input-sm w-full bg-base-100 focus:bg-base-100"
                                                v-model="item.after" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3 flex justify-between items-center">
                                <button class="btn btn-sm btn-ghost"
                                    @click="replaceTextList.push({ before: '', after: '' })">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M12 4v16m8-8H4" />
                                    </svg>
                                    {{ $tt('添加规则') }}
                                </button>
                                <span class="text-xs text-base-content/60">{{ $tt('{count} 条规则', { count: replaceTextList.length }) }}</span>
                            </div>
                            <label class="label">
                                <span class="label-text-alt text-base-content/60">
                                    {{ $tt('支持普通文本匹配和正则表达式匹配（根据替换模式）') }}
                                </span>
                            </label>
                        </div>

                        <!-- 常用模式 -->
                        <div class="bg-base-200/50 rounded-lg p-4 border border-base-300/50">
                            <h4 class="font-medium mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                                {{ $tt('常用模式') }}
                            </h4>
                            <div class="grid grid-cols-1 gap-2">
                                <div class="text-xs space-y-1">
                                    <div class="flex items-center gap-2">
                                        <kbd class="kbd kbd-xs">[]</kbd>
                                        <code class="text-xs bg-base-300/50 px-2 py-1 rounded">\\[.*?\\]</code>
                                        <span class="text-xs text-base-content/60">{{ $tt('移除方括号内容') }}</span>
                                    </div>
                                    <div class="flex items-center gap-2">
                                        <kbd class="kbd kbd-xs">()</kbd>
                                        <code class="text-xs bg-base-300/50 px-2 py-1 rounded">\\(.*?\\)</code>
                                        <span class="text-xs text-base-content/60">{{ $tt('移除圆括号内容') }}</span>
                                    </div>
                                    <div class="flex items-center gap-2">
                                        <kbd class="kbd kbd-xs">feat</kbd>
                                        <code class="text-xs bg-base-300/50 px-2 py-1 rounded">feat\\.|featuring</code>
                                        <span class="text-xs text-base-content/60">{{ $tt('移除合作标识') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 操作按钮 -->
                        <div class="flex gap-3 pt-4 border-t border-base-300">
                            <button class="btn btn-primary btn-sm flex-1" @click="openPreviewDrawer('replace_text')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                                {{ $tt('预览效果') }}
                            </button>
                            <div class="tooltip" :data-tip="$tt('清空所有规则')">
                                <button class="btn btn-ghost btn-sm"
                                    @click="replaceTextList = [{ before: '', after: '' }]">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 预览抽屉 -->
        <div class="drawer drawer-end z-10">
            <input id="preview-drawer" type="checkbox" class="drawer-toggle" v-model="previewDrawerCheckBox" />
            <div class="drawer-side">
                <label for="preview-drawer" @click="previewDrawerCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="min-h-full bg-base-100 text-base-content w-80 md:w-[600px]">
                    <!-- 头部区域 -->
                    <div class="sticky top-0 z-10 bg-base-100 px-6 py-4">
                        <div class="flex justify-between items-center">
                            <div class="flex items-center gap-3">
                                <div class="p-2 bg-success/10 rounded-lg">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-success" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                </div>
                                <div>
                                    <h2 class="text-lg font-semibold text-base-content">{{ $tt('预览结果') }}</h2>
                                    <p class="text-sm text-base-content/70">{{ $tt('实时预览处理效果') }}</p>
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button class="btn btn-sm btn-ghost" @click="previewDrawerCheckBox = false">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                    {{ $tt('关闭') }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- 内容区域 -->
                    <div class="p-6 space-y-6">
                        <!-- 拆分元数据预览 -->
                        <div v-if="currentPreviewMode === 'split_filename'" class="space-y-6">
                            <div class="bg-base-200/30 rounded-lg p-4 border border-base-300/50 space-y-3">
                                <div class="flex items-center justify-between gap-3">
                                    <h3 class="font-medium">{{ isEditingSplitRule ? $tt('编辑规则') : $tt('新建规则') }}</h3>
                                    <div class="flex items-center gap-2">
                                        <button class="btn btn-xs btn-primary" @click="submitRuleDialog">{{ $tt('保存') }}</button>
                                        <button class="btn btn-xs btn-ghost" @click="resetSplitRuleEditor">{{ $tt('重置') }}</button>
                                    </div>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                                    <div class="form-control">
                                        <input v-model.trim="ruleForm.name" type="text" class="input input-bordered input-sm w-full"
                                            :placeholder="$tt('规则名称')" />
                                    </div>
                                    <div class="form-control">
                                        <select class="select select-bordered select-sm" v-model="ruleForm.source">
                                            <option v-for="option in extractList" :key="option.id" :value="option.id">{{ option.name }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-control">
                                    <textarea v-model.trim="ruleForm.remark" class="textarea textarea-bordered textarea-sm h-20"
                                        :placeholder="$tt('备注说明')"></textarea>
                                </div>

                                <label class="label cursor-pointer justify-start gap-3 py-0">
                                    <input type="checkbox" class="checkbox checkbox-sm" v-model="ruleForm.enabled" />
                                    <span class="label-text text-sm">{{ $tt('启用此规则') }}</span>
                                </label>

                                <div class="text-xs text-base-content/60">
                                    {{ $tt('规则编辑与预览已整合，完整正则在下方 AI/预览区域维护') }}
                                </div>
                            </div>

                            <!-- AI 生成区域 -->
                            <div
                                class="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-lg p-4 border border-purple-200/50 dark:border-purple-700/50">
                                <div class="flex items-center justify-between gap-3 mb-3">
                                    <div class="flex items-center gap-2">
                                        <svg-icon name="ai" class="w-5 h-5 fill-purple-600 dark:fill-purple-400" />
                                        <h3 class="font-medium text-purple-800 dark:text-purple-200">{{ $tt('AI 智能生成') }}</h3>
                                    </div>
                                    <button class="btn btn-ghost btn-xs" @click="splitAIPanelExpanded = !splitAIPanelExpanded">
                                        {{ splitAIPanelExpanded ? $tt('收起提示') : $tt('展开提示') }}
                                    </button>
                                </div>

                                <div v-if="splitAIPanelExpanded" class="space-y-4 mb-4">
                                    <div class="bg-base-200/50 rounded-lg p-4">
                                        <div class="flex items-start gap-3">
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                class="w-5 h-5 text-info mt-0.5 flex-shrink-0" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                                            </svg>
                                            <div>
                                                <h4 class="font-medium text-info mb-2">{{ $tt('使用教程') }}</h4>
                                                <div class="text-sm text-base-content/70 space-y-1">
                                                    <div class="flex items-center flex-wrap">
                                                        <span>{{ $tt('1. 请将下面样例文本中的') }}</span>
                                                        <span
                                                            class="mx-1 px-2 py-1 bg-accent/20 text-accent rounded text-xs font-mono">01.
                                                            {{ $tt('夜曲[xx出品]') }}</span>
                                                        <span>{{ $tt('替换为你需要拆分的文件名') }}</span>
                                                    </div>
                                                    <div class="flex items-center flex-wrap">
                                                        <span>{{ $tt('2. 拆分后的元数据范围：') }}</span>
                                                        <span
                                                            class="mx-1 px-2 py-1 bg-accent/20 text-accent rounded text-xs font-mono">{{ $tt('音轨号(tracknumber)和歌曲名(title)') }}</span>
                                                        <span>{{ $tt('改为你想要提取的元数据') }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-control">
                                        <label class="label">
                                            <span class="label-text font-medium">{{ $tt('AI 提示词') }}</span>
                                        </label>
                                        <textarea
                                            class="textarea textarea-bordered textarea-sm w-full h-32 bg-base-100 focus:bg-base-100"
                                            :placeholder="$tt('描述你的拆分需求...')" v-model="splitFilenamePrompt"></textarea>
                                    </div>
                                </div>

                                <!-- 生成按钮 -->
                                <button class="btn btn-sm btn-primary w-full" @click="askRegex('split_filename')"
                                    :disabled="isLoadingRegex">
                                    <svg-icon name="ai" class="w-4 h-4 mr-2 fill-current" v-if="!isLoadingRegex" />
                                    <span class="loading loading-infinity loading-md" v-else></span>
                                    {{ isLoadingRegex ? $tt('正在生成...') : $tt('生成正则表达式') }}
                                </button>

                                <!-- 生成结果 -->
                                <div class="mt-4">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('正则表达式') }}</span>
                                    </label>
                                    <div class="relative">
                                        <input type="text" :placeholder="$tt('AI生成的正则表达式...')"
                                            class="input input-bordered input-sm w-full bg-base-100 focus:bg-base-100 font-mono"
                                            v-model="ruleForm.pattern" />
                                        <button class="btn btn-ghost btn-xs absolute right-2 top-1/2 -translate-y-1/2"
                                            @click="copyToClipboard(ruleForm.pattern)">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- 预览测试区域 -->
                            <div class="bg-base-200/30 rounded-lg p-4 border border-base-300/50">
                                <div class="flex items-center gap-2 mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-success" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <h3 class="font-medium text-success">{{ $tt('预览测试') }}</h3>
                                </div>

                                <div class="form-control mb-4">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('示例文本') }}</span>
                                    </label>
                                    <input type="text" :placeholder="$tt('请输入测试文本...')"
                                        class="input input-bordered input-sm w-full bg-base-100 focus:bg-base-100"
                                        v-model="ruleForm.previewText" />
                                </div>

                                <button class="btn btn-sm btn-success w-full mb-4 text-white" @click="previewSingleRule">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-2" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    {{ $tt('执行预览') }}
                                </button>

                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('执行结果') }}</span>
                                    </label>
                                    <textarea
                                        class="textarea textarea-bordered textarea-sm w-full h-32 bg-base-100 font-mono"
                                        v-model="ruleForm.previewResult" readonly></textarea>
                                    <label class="label">
                                        <span class="label-text-alt text-base-content/60">
                                            {{ $tt('将文件名提取出的音轨号(tracknumber)、歌曲名(title)赋值给元数据中') }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- 替换文本预览 -->
                        <div v-if="currentPreviewMode === 'replace_text'" class="space-y-6">
                            <!-- AI 生成区域 -->
                            <div
                                class="bg-gradient-to-r from-blue-50 to-cyan-50 dark:from-blue-900/20 dark:to-cyan-900/20 rounded-lg p-4 border border-blue-200/50 dark:border-blue-700/50">
                                <div class="flex items-center gap-2 mb-3">
                                    <svg-icon name="ai" class="w-5 h-5 fill-blue-600 dark:fill-blue-400" />
                                    <h3 class="font-medium text-blue-800 dark:text-blue-200">{{ $tt('AI 智能生成') }}</h3>
                                </div>

                                <!-- 教程卡片 -->
                                <div class="bg-base-200/50 rounded-lg p-4 mb-4">
                                    <div class="flex items-start gap-3">
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                            class="w-5 h-5 text-info mt-0.5 flex-shrink-0" fill="none"
                                            viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                                        </svg>
                                        <div>
                                            <h4 class="font-medium text-info mb-2">{{ $tt('使用教程') }}</h4>
                                            <div class="text-sm text-base-content/70">
                                                <div class="flex items-center flex-wrap">
                                                    <span>{{ $tt('请将下面样例文本中的') }}</span>
                                                    <span
                                                        class="mx-1 px-2 py-1 bg-accent/20 text-accent rounded text-xs font-mono">01.
                                                        {{ $tt('夜曲[xx出品]') }}</span>
                                                    <span>{{ $tt('替换为你需要操作的文件名') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 提示词输入 -->
                                <div class="form-control mb-4">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('AI 提示词') }}</span>
                                    </label>
                                    <textarea
                                        class="textarea textarea-bordered textarea-sm w-full h-32 bg-base-100 focus:bg-base-100"
                                        :placeholder="$tt('描述你的替换需求...')" v-model="replaceTextPrompt"></textarea>
                                </div>

                                <!-- 生成按钮 -->
                                <button class="btn btn-sm btn-primary w-full" @click="askRegex('replace_text')"
                                    :disabled="isLoadingRegexReplace">
                                    <svg-icon name="ai" class="w-4 h-4 mr-2 fill-current"
                                        v-if="!isLoadingRegexReplace" />
                                    <span class="loading loading-infinity loading-md" v-else></span>
                                    {{ isLoadingRegexReplace ? $tt('正在生成...') : $tt('生成正则表达式') }}
                                </button>

                                <!-- 生成结果 -->
                                <div class="mt-4">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('正则表达式') }}</span>
                                    </label>
                                    <div class="relative">
                                        <input type="text" :placeholder="$tt('AI生成的正则表达式...')"
                                            class="input input-bordered input-sm w-full bg-base-100 focus:bg-base-100 font-mono"
                                            v-model="replaceTextRegex" />
                                        <button class="btn btn-ghost btn-xs absolute right-2 top-1/2 -translate-y-1/2"
                                            @click="copyToClipboard(replaceTextRegex)">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- 预览测试区域 -->
                            <div class="bg-base-200/30 rounded-lg p-4 border border-base-300/50">
                                <div class="flex items-center gap-2 mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-success" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <h3 class="font-medium text-success">{{ $tt('预览测试') }}</h3>
                                </div>

                                <div class="form-control mb-4">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('示例文本') }}</span>
                                    </label>
                                    <input type="text" :placeholder="$tt('请输入测试文本...')"
                                        class="input input-bordered input-sm w-full bg-base-100 focus:bg-base-100"
                                        v-model="previewText2" />
                                </div>

                                <button class="btn btn-sm btn-success w-full mb-4 text-white" @click="executePreview">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-2" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    {{ $tt('执行预览') }}
                                </button>

                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('执行结果') }}</span>
                                    </label>
                                    <textarea
                                        class="textarea textarea-bordered textarea-sm w-full h-32 bg-base-100 font-mono"
                                        v-model="previewTextarea2" readonly></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SingleSelect from "@/components/iview/SingleSelect";
import MultiSelect from "@/components/iview/MultiSelect";
import SvgIcon from '@/components/SvgIcon.vue';

const SPLIT_RULE_CONFIG_KEY = 'split_rule_configs'

function createRuleId(source = 'filename') {
    return `${source}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
}

function createSplitRule({
    id,
    name = '',
    pattern = '',
    enabled = true,
    remark = '',
    source = 'filename',
    previewText = ''
} = {}) {
    return {
        id: id || createRuleId(source),
        name,
        pattern,
        enabled,
        remark,
        source,
        previewText,
    }
}

function buildDefaultSplitRuleConfigs(tt) {
    return {
        filename: [
            createSplitRule({
                source: 'filename',
                name: tt('标准文件名：序号 + 标题'),
                pattern: '(?P<tracknumber>\\d+)\\.([\\s]+)(?P<title>.+)',
                enabled: true,
                remark: tt('适用于 01. 夜曲 这类文件名'),
                previewText: tt('01. 夜曲')
            }),
            createSplitRule({
                source: 'filename',
                name: tt('文件名：序号 空格 标题'),
                pattern: '(?P<tracknumber>\\w+) (?P<title>.+)',
                enabled: true,
                remark: tt('适用于 01 夜曲 这类文件名'),
                previewText: tt('01 夜曲')
            }),
            createSplitRule({
                source: 'filename',
                name: tt('文件名：标题-艺术家-专辑'),
                pattern: '(?P<title>.+)-(?P<artist>.+)-(?P<album>.+)',
                enabled: false,
                remark: tt('适用于 标题-艺术家-专辑 结构'),
                previewText: tt('夜曲-周杰伦-十一月的萧邦')
            })
        ],
        title: [
            createSplitRule({
                source: 'title',
                name: tt('标题：序号 + 标题'),
                pattern: '(?P<tracknumber>\\d+)\\.([\\s]+)(?P<title>.+)',
                enabled: true,
                remark: tt('适用于标题字段中含音轨序号'),
                previewText: tt('01. 夜曲')
            }),
            createSplitRule({
                source: 'title',
                name: tt('标题：序号 空格 标题'),
                pattern: '(?P<tracknumber>\\w+) (?P<title>.+)',
                enabled: true,
                remark: tt('适用于标题字段中以空格分隔的场景'),
                previewText: tt('01 夜曲')
            })
        ],
        lyrics: [
            createSplitRule({
                source: 'lyrics',
                name: tt('歌词提取：作曲'),
                pattern: '作曲.*[:：]{1}(?P<composer>.*)\\n',
                enabled: true,
                remark: tt('从歌词中提取作曲信息'),
                previewText: '作曲：周杰伦\n作词：方文山\n'
            }),
            createSplitRule({
                source: 'lyrics',
                name: tt('歌词提取：作词'),
                pattern: '作词.*[:：]{1}(?P<lyricist>.*)\\n',
                enabled: true,
                remark: tt('从歌词中提取作词信息'),
                previewText: '作曲：周杰伦\n作词：方文山\n'
            }),
            createSplitRule({
                source: 'lyrics',
                name: tt('歌词提取：Composed by'),
                pattern: 'Composed by.*[:：]{1}(?P<composer>.*)\\n',
                enabled: false,
                remark: tt('适用于英文歌词头信息'),
                previewText: 'Composed by: Jay Chou\nLyrics by: Vincent Fang\n'
            }),
            createSplitRule({
                source: 'lyrics',
                name: tt('歌词提取：Lyrics by'),
                pattern: 'Lyrics by.*[:：]{1}(?P<lyricist>.*)\\n',
                enabled: false,
                remark: tt('适用于英文歌词头信息'),
                previewText: 'Composed by: Jay Chou\nLyrics by: Vincent Fang\n'
            })
        ]
    }
}

function parseNamedGroups(pattern = '') {
    const matches = pattern.match(/\(\?P<([^>]+)>/g) || []
    return matches.map(item => item.replace('(?P<', '').replace('>', ''))
}

export default {
    name: 'TextProcessor',
    components: { SingleSelect, MultiSelect, SvgIcon },
    props: {
        detail: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        checkedData: {
            type: Array,
            default: () => []
        },
        filePath: {
            type: String,
            default: ''
        },
        cardMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            splitFilenameCheckBox: false,
            replaceTextCheckBox: false,
            languageDrawerOpen: false,
            encodingDrawerOpen: false,
            languageType: 'sim2trad',
            modifyListL: ['title', 'artist', 'album'],
            autoDetectEncoding: true,
            backupOriginal: false,
            modifyListLanguage: [
                { id: 'title', name: this.$tt('标题') },
                { id: 'artist', name: this.$tt('艺术家') },
                { id: 'album', name: this.$tt('专辑') },
                { id: 'albumartist', name: this.$tt('专辑艺术家') },
                { id: 'lyrics', name: this.$tt('歌词') },
                { id: 'comment', name: this.$tt('简介') },
                { id: 'description', name: this.$tt('描述') },
                { id: 'filename', name: this.$tt('文件名称') },
                { id: 'genre', name: this.$tt('风格') },
                { id: 'composer', name: this.$tt('作曲家') },
                { id: 'lyricist', name: this.$tt('作词家') },
            ],
            replaceOptions: [
                { id: 'text', name: this.$tt('全文替换') },
                { id: 'regex', name: this.$tt('正则替换') }
            ],
            extractField: 'filename',
            extractList: [
                { id: 'filename', name: this.$tt('文件名') },
                { id: 'title', name: this.$tt('标题') },
                { id: 'lyrics', name: this.$tt('歌词') }
            ],
            splitRuleConfigs: buildDefaultSplitRuleConfigs(this.$tt),
            editingRuleIndex: null,
            splitRulesLoaded: false,
            ruleForm: {
                id: '',
                name: '',
                pattern: '',
                enabled: true,
                remark: '',
                source: 'filename',
                previewText: '',
                previewResult: ''
            },
            replaceMode: 'text',
            replaceTextList: [
                { 'before': '', 'after': '' }
            ],
            previewText: this.$tt('01. 夜曲'),
            previewTextarea: this.$tt('{"tracknumber":"01","title":"夜曲"}'),
            previewText2: this.$tt('01. 夜曲[xx出品]'),
            previewTextarea2: this.$tt('01. 夜曲[xx出品]'),
            previewDrawerCheckBox: false,
            currentPreviewMode: null,
            splitFilenamePrompt: this.$tt('## 我的文件名是\n01. 夜曲\n ## 你的任务\n提取出音轨号(tracknumber)和歌曲名(title)'),
            splitFilenameRegex: '',
            splitAIPanelExpanded: false,
            replaceTextPrompt: this.$tt('## 我的示例文本是\n01. 夜曲[xx出品]\n## 你的任务\n移除所有[]中的内容，包括[]'),
            isLoadingRegex: false,
            isLoadingRegexReplace: false,
            replaceTextRegex: '',
            languageOptions: [
                { id: 'sim2trad', name: this.$tt('简体转繁体') },
                { id: 'trad2sim', name: this.$tt('繁体转简体') }
            ]
        }
    },
    computed: {
        languageTypeLabel() {
            return this.languageOptions.find(opt => opt.id === this.languageType)?.name || this.$tt('简体转繁体')
        },
        currentSplitRules() {
            return this.splitRuleConfigs[this.extractField] || []
        },
        enabledSplitRules() {
            return this.currentSplitRules.filter(item => item.enabled && item.pattern && item.pattern.trim())
        },
        enabledSplitRulePatterns() {
            return this.enabledSplitRules.map(item => item.pattern.trim())
        },
        currentExtractLabel() {
            return this.extractList.find(item => item.id === this.extractField)?.name || this.extractField
        },
        isEditingSplitRule() {
            return this.editingRuleIndex !== null
        }
    },
    created() {
        this.loadSplitRuleConfigs()
    },
    methods: {
        getDefaultSplitRuleConfigs() {
            return buildDefaultSplitRuleConfigs(this.$tt)
        },

        createEmptyRule(source = this.extractField) {
            return {
                id: createRuleId(source),
                name: '',
                pattern: '',
                enabled: true,
                remark: '',
                source,
                previewText: '',
                previewResult: ''
            }
        },

        normalizeRule(rule, source, index = 0) {
            if (typeof rule === 'string') {
                return createSplitRule({
                    source,
                    name: this.$tt('规则 {index}', { index: index + 1 }),
                    pattern: rule,
                    enabled: true,
                    remark: ''
                })
            }

            return createSplitRule({
                id: rule.id,
                source,
                name: rule.name || this.$tt('规则 {index}', { index: index + 1 }),
                pattern: rule.pattern || '',
                enabled: rule.enabled !== false,
                remark: rule.remark || '',
                previewText: rule.previewText || ''
            })
        },

        normalizeSplitRuleConfigs(configs) {
            const sources = ['filename', 'title', 'lyrics']
            const normalized = {}

            sources.forEach((source) => {
                const sourceRules = Array.isArray(configs?.[source]) ? configs[source] : []
                normalized[source] = sourceRules.map((rule, index) => this.normalizeRule(rule, source, index))
            })

            return normalized
        },

        async loadSplitRuleConfigs() {
            try {
                const response = await this.$api.Task.getSys({ key: SPLIT_RULE_CONFIG_KEY })
                const items = response?.data?.items || []
                const setting = items.find(item => item.key === SPLIT_RULE_CONFIG_KEY)

                if (setting && setting.value) {
                    this.splitRuleConfigs = this.normalizeSplitRuleConfigs(JSON.parse(setting.value))
                } else {
                    this.splitRuleConfigs = this.getDefaultSplitRuleConfigs()
                    await this.saveSplitRuleConfigs(true)
                }
            } catch (error) {
                this.splitRuleConfigs = this.getDefaultSplitRuleConfigs()
                this.$myMsg.notify({
                    title: this.$tt('加载失败！'),
                    content: error.message || this.$tt('加载拆分规则失败，已使用默认规则'),
                    type: 'warning',
                    time: 3000,
                })
            } finally {
                this.splitRulesLoaded = true
            }
        },

        serializeSplitRuleConfigs() {
            const result = {}
            Object.keys(this.splitRuleConfigs).forEach((source) => {
                result[source] = (this.splitRuleConfigs[source] || []).map(rule => ({
                    id: rule.id,
                    name: rule.name,
                    pattern: rule.pattern,
                    enabled: rule.enabled,
                    remark: rule.remark,
                    source: rule.source || source,
                    previewText: rule.previewText || ''
                }))
            })
            return result
        },

        async saveSplitRuleConfigs(silent = false) {
            try {
                await this.$api.Task.UpdateSys({
                    key: SPLIT_RULE_CONFIG_KEY,
                    value: JSON.stringify(this.serializeSplitRuleConfigs())
                })

                if (!silent) {
                    this.$myMsg.notify({
                        title: this.$tt('保存成功！'),
                        content: this.$tt('拆分规则配置已保存到服务器'),
                        type: 'success',
                        time: 2000,
                    })
                }
            } catch (error) {
                if (!silent) {
                    this.$myMsg.notify({
                        title: this.$tt('保存失败！'),
                        content: error.message || this.$tt('保存拆分规则配置失败'),
                        type: 'error',
                        time: 3000,
                    })
                }
                throw error
            }
        },

        getRuleFields(rule) {
            return parseNamedGroups(rule?.pattern || '')
        },

        openLanguageDrawer() {
            this.languageDrawerOpen = true
        },
        
        openEncodingDrawer() {
            this.encodingDrawerOpen = true
        },
        
        handleChangeLanguage() {
            this.languageDrawerOpen = true
        },
        
        handleEncodingFix() {
            this.fixEncodingFunc()
            this.encodingDrawerOpen = false
        },

        handleChangeLanguageFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.simplifiedFields({
                'mode': this.languageType,
                'modify_list': this.modifyListL,
                'file_full_path': this.filePath,
                'select_data': this.checkedData
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        splitFilenameFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            if (!this.enabledSplitRulePatterns.length) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请至少启用一条有效的拆分规则'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.splitFilename({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'rule_list': this.enabledSplitRulePatterns,
                'extract_field': this.extractField
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                    })
                    this.splitFilenameCheckBox = false
                    this.$parent.handleSearchFile && this.$parent.handleSearchFile()
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        replaceTextFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.replaceText({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'replace_text_list': this.replaceTextList,
                'modify_list': this.modifyListL,
                'replace_mode': this.replaceMode
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                    })
                    this.$parent.handleSearchFile && this.$parent.handleSearchFile()
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        fixEncodingFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.fixEncoding({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'modify_list': this.modifyListL
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                    })
                    this.$parent.handleSearchFile && this.$parent.handleSearchFile()
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        handleExtractChange() {
            if (!this.splitRulesLoaded) {
                return
            }
        },

        openPreviewDrawer(mode) {
            this.currentPreviewMode = mode;
            if (mode === 'split_filename') {
                this.resetSplitRuleEditor()
            }
            this.previewDrawerCheckBox = true;
        },

        executePreview() {
            if (this.currentPreviewMode === 'split_filename') {
                this.previewFunc(this.currentPreviewMode);
            } else if (this.currentPreviewMode === 'replace_text') {
                this.previewFunc2(this.currentPreviewMode);
            }
        },

        previewFunc(mode) {
            if (!this.enabledSplitRulePatterns.length) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请至少启用一条有效的拆分规则'),
                    type: 'warning',
                    time: 5000,
                })
                return
            }

            this.$api.Task.previewRegex({
                'preview_text': this.previewText,
                'mode': mode,
                'rule_list': this.enabledSplitRulePatterns
            }).then((res) => {
                if (res.result) {
                    this.previewTextarea = JSON.stringify(res.data)
                    this.$myMsg.notify({
                        title: this.$tt('预览成功！'),
                        content: JSON.stringify(res.data),
                        type: 'success',
                        time: 5000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('预览失败！'),
                        content: res.message,
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },

        previewFunc2(mode) {
            this.$api.Task.previewRegex({
                'preview_text': this.previewText2,
                'mode': mode,
                'rule_list': [
                    { 'before': this.replaceTextRegex, 'after': '' },
                ],
                'replace_mode': 'regex'
            }).then((res) => {
                if (res.result) {
                    this.previewTextarea2 = res.data
                    this.$myMsg.notify({
                        title: this.$tt('预览成功！'),
                        content: res.data,
                        type: 'success',
                        time: 5000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('预览失败！'),
                        content: res.message,
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },
        askRegex(mode) {
            if (mode === 'split_filename') {
                this.isLoadingRegex = true
            } else if (mode === 'replace_text') {
                this.isLoadingRegexReplace = true
            }
            let prompt = ''
            if (mode === 'split_filename') {
                prompt = this.splitFilenamePrompt
            } else if (mode === 'replace_text') {
                prompt = this.replaceTextPrompt
            }
            this.$api.agents.askRegex({
                'track_info': {
                    'mode': mode,
                    'prompt': prompt
                }
            }).then((res) => {
                this.isLoadingRegex = false
                this.isLoadingRegexReplace = false
                if (res.result) {
                    if (mode === 'split_filename') {
                        this.splitFilenameRegex = res.data
                        this.ruleForm.pattern = res.data
                    } else if (mode === 'replace_text') {
                        this.replaceTextRegex = res.data
                    }
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('生成失败！'),
                        content: res.message,
                        type: 'error',
                    })
                }
            }).catch(() => {
                this.isLoadingRegex = false
                this.isLoadingRegexReplace = false
            })
        },

        openSplitRuleEditor(rule = null, index = null) {
            const targetRule = rule ? { ...rule } : this.createEmptyRule(this.extractField)
            this.editingRuleIndex = index
            this.ruleForm = {
                id: targetRule.id,
                name: targetRule.name || '',
                pattern: targetRule.pattern || '',
                enabled: targetRule.enabled !== false,
                remark: targetRule.remark || '',
                source: targetRule.source || this.extractField,
                previewText: targetRule.previewText || this.previewText || '',
                previewResult: ''
            }
            this.currentPreviewMode = 'split_filename'
            this.previewDrawerCheckBox = true
        },

        resetSplitRuleEditor() {
            this.editingRuleIndex = null
            this.ruleForm = this.createEmptyRule(this.extractField)
            this.ruleForm.previewText = this.previewText
            this.ruleForm.previewResult = ''
        },

        async submitRuleDialog() {
            if (!this.ruleForm.name.trim()) {
                this.$myMsg.notify({
                    title: this.$tt('保存失败！'),
                    content: this.$tt('请输入规则名称'),
                    type: 'error',
                    time: 2000,
                })
                return
            }

            if (!this.ruleForm.pattern.trim()) {
                this.$myMsg.notify({
                    title: this.$tt('保存失败！'),
                    content: this.$tt('请输入正则表达式'),
                    type: 'error',
                    time: 2000,
                })
                return
            }

            const oldSource = this.editingRuleIndex === null ? null : this.extractField
            const newRule = createSplitRule({
                id: this.ruleForm.id,
                name: this.ruleForm.name.trim(),
                pattern: this.ruleForm.pattern.trim(),
                enabled: this.ruleForm.enabled,
                remark: this.ruleForm.remark.trim(),
                source: this.ruleForm.source,
                previewText: this.ruleForm.previewText || ''
            })

            if (this.editingRuleIndex !== null && oldSource) {
                this.splitRuleConfigs[oldSource].splice(this.editingRuleIndex, 1)
            }
            this.splitRuleConfigs[newRule.source].push(newRule)
            if (this.editingRuleIndex !== null && newRule.source === oldSource) {
                const latestIndex = this.splitRuleConfigs[newRule.source].length - 1
                const inserted = this.splitRuleConfigs[newRule.source].splice(latestIndex, 1)[0]
                this.splitRuleConfigs[newRule.source].splice(this.editingRuleIndex, 0, inserted)
            }
            this.extractField = newRule.source

            await this.saveSplitRuleConfigs()
            this.previewText = this.ruleForm.previewText || this.previewText
            this.previewTextarea = this.ruleForm.previewResult || this.previewTextarea
            this.resetSplitRuleEditor()
        },

        async deleteRule(index) {
            this.splitRuleConfigs[this.extractField].splice(index, 1)
            await this.saveSplitRuleConfigs()
        },

        async handleRuleToggle() {
            await this.saveSplitRuleConfigs(true)
        },

        async setCurrentRulesEnabled(enabled) {
            this.currentSplitRules.forEach(rule => {
                rule.enabled = enabled
            })
            await this.saveSplitRuleConfigs(true)
        },

        async restoreDefaultRules() {
            const defaults = this.getDefaultSplitRuleConfigs()
            this.$set(this.splitRuleConfigs, this.extractField, defaults[this.extractField])
            await this.saveSplitRuleConfigs()
        },

        async previewSingleRule() {
            if (!this.ruleForm.pattern.trim()) {
                this.$myMsg.notify({
                    title: this.$tt('预览失败！'),
                    content: this.$tt('请输入正则表达式'),
                    type: 'error',
                    time: 2000,
                })
                return
            }

            const previewText = this.ruleForm.previewText || this.previewText
            const res = await this.$api.Task.previewRegex({
                preview_text: previewText,
                mode: 'split_filename',
                rule_list: [this.ruleForm.pattern.trim()]
            })
            this.ruleForm.previewResult = JSON.stringify(res.data)
            this.previewText = previewText
            this.previewTextarea = this.ruleForm.previewResult
        },

        copyToClipboard(text) {
            if (!text) return

            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(() => {
                    this.$myMsg.notify({
                        title: this.$tt('复制成功！'),
                        content: this.$tt('已复制到剪贴板'),
                        type: 'success',
                        time: 2000,
                    })
                }).catch(() => {
                    this.fallbackCopyTextToClipboard(text)
                })
            } else {
                this.fallbackCopyTextToClipboard(text)
            }
        },

        fallbackCopyTextToClipboard(text) {
            const textArea = document.createElement('textarea')
            textArea.value = text
            textArea.style.position = 'fixed'
            textArea.style.left = '-999999px'
            textArea.style.top = '-999999px'
            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()

            try {
                document.execCommand('copy')
                this.$myMsg.notify({
                    title: this.$tt('复制成功！'),
                    content: this.$tt('已复制到剪贴板'),
                    type: 'success',
                    time: 2000,
                })
            } catch (err) {
                this.$myMsg.notify({
                    title: this.$tt('复制失败！'),
                    content: this.$tt('请手动复制'),
                    type: 'error',
                    time: 3000,
                })
            }

            document.body.removeChild(textArea)
        }
    }
}
</script>

<style scoped>
.icon {
    @apply fill-current w-16;
}
</style>
